import { render, staticRenderFns } from "./AttributeRuleManage.vue?vue&type=template&id=20a07ee0&scoped=true"
import script from "./AttributeRuleManage.vue?vue&type=script&lang=js"
export * from "./AttributeRuleManage.vue?vue&type=script&lang=js"
import style0 from "./AttributeRuleManage.vue?vue&type=style&index=0&id=20a07ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a07ee0",
  null
  
)

export default component.exports